<template>
    <transition name="slide">
        <div class="modal fade" tabindex="-1" role="dialog" :class="onfilter ? 'show' : 'show'" :style="onfilter ? 'display: block; padding-left: 0px;' : ''">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content shadow-3">
                    <div class="modal-header">
                        <div class="icon icon-shape rounded-3 bg-soft-primary text-primary text-lg me-4">
                            <i class="bi bi-funnel"></i>
                        </div>
                        <div>
                            <h5 class="mb-1">Filtro</h5>
                            <small class="d-block text-xs text-muted">Aplica los filtros para obtener la información que necesites.</small>
                        </div>
                        <div class="ms-auto">
                        </div>
                    </div>
                    <div class="modal-body">
                        <div class="vstack gap-3">
                            <div>
                                <div class="row">
                                    <div class="col-md-4 pl-0 pr-0 pr-2">
                                        <small class="input-title">Operador</small>
                                        <v-select v-model="filter.operator"
                                            :items="operators"
                                            item-value="id"
                                            item-text="name"
                                            hide-details
                                            class="form-control form-control-sm">
                                        </v-select>
                                    </div>
                                    <div class="col-md-8 pl-0 pr-0">
                                        <small class="input-title">Campos</small>
                                        <v-select v-model="filter.fields"
                                            :items="fields"
                                            item-value="id"
                                            item-text="name"
                                            multiple
                                            hide-details
                                            class="form-control form-control-sm">
                                        </v-select>
                                    </div>
                                </div>
                            </div>
                            <div v-if="String(exclude.find((e) => e == 'date')) == 'undefined'">
                                <div class="row">
                                    <div class="col-md-6 pl-0 pr-0 pr-2">
                                        <small class="input-title">Desde</small>
                                        <v-menu v-model="menu_start"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field 
                                                    :value="filter.start_date" 
                                                    v-bind="attrs" 
                                                    v-on="on" 
                                                    hide-details
                                                    dense
                                                    readonly 
                                                    clearable
                                                    class="form-control form-control-sm" 
                                                    @click:clear="filter.start_date = ''">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="filter.start_date" 
                                                no-title 
                                                scrollable
                                                @input="menu_start = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                    <div class="col-md-6 pl-0 pr-0">
                                        <small class="input-title">Hasta</small>
                                        <v-menu v-model="menu_end"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field 
                                                    :value="filter.end_date" 
                                                    v-bind="attrs" 
                                                    v-on="on" 
                                                    hide-details
                                                    dense
                                                    readonly 
                                                    clearable
                                                    class="form-control form-control-sm" 
                                                    @click:clear="filter.end_date = ''">
                                                </v-text-field>
                                            </template>
                                            <v-date-picker 
                                                v-model="filter.end_date" 
                                                no-title 
                                                scrollable
                                                @input="menu_end = false">
                                            </v-date-picker>
                                        </v-menu>
                                    </div>
                                </div>
                            </div>
                            <div v-if="String(exclude.find((e) => e == 'user_id')) == 'undefined'">
                                <small class="input-title">Cliente</small>
                                <search-user v-model="filter.user" @set_value="e => filter.user_id = e" clearable/>
                            </div>
                            <div v-if="String(exclude.find((e) => e == 'state_id')) == 'undefined'">
                                <small class="input-title">Estado</small>
                                <v-autocomplete v-model="filter.state_id" multiple :items="states" item-value="id" @click:clear="filter.state_id = []"
                                    item-text="name" hide-details clearable
                                    class="form-control form-control-sm">
                                    <template v-slot:prepend-item>
                                        <v-list-item ripple @mousedown.prevent @click="toggle">
                                            <v-list-item-action>
                                                <v-icon :color="filter.state_id.length > 0 ? 'indigo darken-4' : ''">
                                                {{ icon }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                Select All
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                    <template v-slot:selection="{ item, index }">
                                        <div class="mr-2" v-if="index === 0">
                                            <span>{{ item.name }}</span>
                                        </div>
                                        <span v-if="index === 1" class="grey--text text-caption">
                                            (+{{ filter.state_id.length - 1 }} others)
                                        </span>
                                    </template>
                                </v-autocomplete>
                            </div>
                            <div v-if="String(exclude.find((e) => e == 'payment_state_id')) == 'undefined'">
                                <small class="input-title">Estado de pago</small>
                                <v-autocomplete v-model="filter.payment_state_id" multiple :items="payment_states" item-value="id" @click:clear="filter.payment_state_id = []"
                                    item-text="name" hide-details clearable
                                    class="form-control form-control-sm">
                                    <template v-slot:prepend-item>
                                        <v-list-item ripple @mousedown.prevent @click="toggle_payment">
                                            <v-list-item-action>
                                                <v-icon :color="filter.payment_state_id.length > 0 ? 'indigo darken-4' : ''">
                                                {{ icon_payment }}
                                                </v-icon>
                                            </v-list-item-action>
                                            <v-list-item-content>
                                                <v-list-item-title>
                                                Select All
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                        <v-divider class="mt-2"></v-divider>
                                    </template>
                                    <template v-slot:selection="{ item, index }">
                                        <div class="mr-2" v-if="index === 0">
                                            <span>{{ item.name }}</span>
                                        </div>
                                        <span v-if="index === 1" class="grey--text text-caption">
                                            (+{{ filter.payment_state_id.length - 1 }} others)
                                        </span>
                                    </template>
                                </v-autocomplete>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-h btn-primary px-3" @click="$emit('onfilter')">Aplicar</button>
                        <button type="button" class="btn btn-h btn-dark px-3" @click="$emit('onclose')">Cancelar</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>
<script>
export default{
    props: {
        onfilter: {
            type: Boolean,
        }, 
        filter: {
            type: Object,
        }, 
        exclude: {
            type: Array,
            default: []
        }
    },
    data(){
        return{
            fields: [
                { name: 'GVT', id: 'id' },
                { name: 'Tracking', id: 'tracking' },
                { name: 'Descripción', id: 'description' },
            ],
            operators: [
                { name: 'Contiene', id: 'LIKE' },
                { name: 'Exacto', id: '==' },
                { name: 'Mayor que', id: '>' },
                { name: 'Menor que', id: '<' }
            ],
            menu_start: false,
            menu_end: false,
            states: [],
            payment_states: [],
        }
    },
    created(){
        this.STATES()
        this.PAYMENT_STATES()
    },
    computed: {
      likesAllStates () {
        return this.filter.state_id.length === this.states.length
      },
      likesSomeStates () {
        return this.filter.state_id.length > 0 && !this.likesAllStates
      },
      icon () {
        if (this.likesAllStates) return 'mdi-close-box'
        if (this.likesSomeStates) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
      likesAllStatesPayment () {
        return this.filter.payment_state_id.length === this.payment_states.length
      },
      likesSomeStatesPayment () {
        return this.filter.payment_state_id.length > 0 && !this.likesAllStatesPayment
      },
      icon_payment () {
        if (this.likesAllStatesPayment) return 'mdi-close-box'
        if (this.likesSomeStatesPayment) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      },
    },
    methods: {
        toggle () {
            this.$nextTick(() => {
                if (this.likesAllStates) {
                    this.filter.state_id = []
                } else {
                    this.filter.state_id = this.states.slice().map(e => e.id)
                }
            })
        },
        toggle_payment () {
            this.$nextTick(() => {
                if (this.likesAllStatesPayment) {
                    this.filter.payment_state_id = []
                } else {
                    this.filter.payment_state_id = this.payment_states.slice().map(e => e.id)
                }
            })
        },
        STATES: function(){
            let vue = this
            axios({url: '/all/states', method: 'GET' })
            .then((resp) => {
                vue.states = resp.data
            })
        },
        PAYMENT_STATES: function(){
            let vue = this
            axios({url: '/all/payment/states', method: 'GET' })
            .then((resp) => {
                vue.payment_states = resp.data
            })
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/packages/modals/Filter.vue